module.exports = __webpack_public_path__ + "img/126.ad60c607.jpg";